import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface getInvCfgRequest extends BaseRequest {
  invId: string; //邀请活动ID
  projectId: string; //项目ID，第十届校赛传3，不传给所有 ,
  projectType: string; //项目类型，校赛传0，不传给所有 ,
}

export interface InvCfgTimeDataVO {
  endTime: string; //结束时间 yyyy-MM-dd HH:mm:ss ,
  projectId: string; //项目ID ,
  projectType: string; //项目类型，校赛传0 ,
  startTime: string; //开始时间 yyyy-MM-dd HH:mm:ss
}
export interface InvCfgTimeRspVO {
  nowTime?: string; //当前服务器时间 ,
  projList?: InvCfgTimeDataVO[]; //邀新项目列表 ,
  taskId?: string; //抽奖TaskId
}

interface getInvCfgResponse extends BaseResponse {
  Data: InvCfgTimeRspVO;
}

/**
 * 获取活动配置
 * @param params
 * @returns
 */
export async function getInvCfg(request: getInvCfgRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getInvCfg');
  return DsbcApi.fetch<getInvCfgResponse>(url, request, true, options);
}
